import { PlaceableTile } from '../config/tiles';
import { ShapeId } from '../config/shapes';

const SAVE_KEY = 'lithoform-save';
const HIGHEST_LEVEL_KEY = 'lithoform-highest-level';

export interface SaveData {
  level: number;
  gridSize: number;
  shapeId?: ShapeId;
  cells: Array<{ tile: PlaceableTile | null; restored: boolean }>;
  current: PlaceableTile;
  next: PlaceableTile;
  isFirstTile: boolean;
  score: number;
  streak: number;
  heat: number;
  harmony?: number;
  patience?: number;
  rhythm?: number;
  shields?: number;
  lastPlayed?: number;
}

export function saveGame(data: SaveData): void {
  localStorage.setItem(SAVE_KEY, JSON.stringify(data));
}

export function loadGame(): SaveData | null {
  const raw = localStorage.getItem(SAVE_KEY);
  if (!raw) return null;

  try {
    const data = JSON.parse(raw) as Record<string, unknown>;
    if (
      typeof data.level !== 'number' ||
      typeof data.gridSize !== 'number' ||
      !Array.isArray(data.cells) ||
      data.cells.length !== data.gridSize * data.gridSize
    ) {
      return null;
    }
    return data as unknown as SaveData;
  } catch {
    return null;
  }
}

export function clearSave(): void {
  localStorage.removeItem(SAVE_KEY);
}

export function hasSave(): boolean {
  return localStorage.getItem(SAVE_KEY) !== null;
}

export function getHighestLevel(): number {
  const stored = localStorage.getItem(HIGHEST_LEVEL_KEY);
  return stored ? parseInt(stored, 10) : 1;
}

export function setHighestLevel(level: number): void {
  const current = getHighestLevel();
  if (level > current) {
    localStorage.setItem(HIGHEST_LEVEL_KEY, String(level));
  }
}
